import {AttributeDescriptor, BaseModel, BaseModelDescriptor} from "./BaseModel";
import {ValidationTypes} from "../core/Validator";

export class Category extends BaseModel {
	id: string
    title: string
    description: string
}

export class CategoryDescriptor extends BaseModelDescriptor{
	static id: AttributeDescriptor = {validation: []}
	static title: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static description: AttributeDescriptor = {validation: []}
}
